import { isEmpty, map } from 'lodash';
import { stringify } from 'qs';
import { BooleanParam, encodeQueryParams, JsonParam, StringParam } from 'use-query-params';

import { ActionDialogType } from 'components/ActionDialog/constants';
import { WorkflowTab } from 'components/StudyDashboard/useStudyDashboardTabState';
import { CasesParams } from 'utils/useCasesParams/types';

export const getStudyMarkerNamingDialogUrl = ({ studyId, labId }: { studyId: string; labId: string }) => {
  const encodedQuery = encodeQueryParams(
    {
      filters: JsonParam,
      labId: StringParam,
      slidesMode: BooleanParam,
      studyDashboardTab: StringParam,
      activeActionDialog: StringParam,
    },
    {
      filters: { studyId },
      labId,
      slidesMode: true,
      studyDashboardTab: WorkflowTab,
      activeActionDialog: ActionDialogType.BulkMultiplexMarkerNaming,
    }
  );

  return `/procedures?${stringify(encodedQuery)}`;
};

export const buildWorkflowMarkerNamingCasesParams = ({
  studyId,
  labId,
  slideIds,
}: {
  studyId: string;
  labId?: string;
  slideIds: string[];
}): CasesParams => ({
  studyId,
  labId,
  filters: { studyId },
  slidesMode: true,
  ...(slideIds.length ? { slideIdsToInclude: slideIds } : {}),
});

export const getMarkerNamingAdditionalParams = ({
  slideId,
  caseId,
}: {
  slideId?: string;
  caseId?: string | number;
}) => {
  if (slideId) {
    return { slideIdsToInclude: [slideId] };
  }

  if (caseId != null && caseId !== '') {
    return { caseIdsToInclude: [Number(caseId)] };
  }

  return undefined;
};

export const applyMarkerNamingCasesParams = (
  casesParams: CasesParams,
  additionalParams?: Record<string, unknown> | null
): CasesParams => {
  const slideIdsToInclude = additionalParams?.slideIdsToInclude as string[] | undefined;
  if (!isEmpty(slideIdsToInclude)) {
    return {
      ...casesParams,
      slidesMode: true,
      slideIdsToInclude,
      slideIdsToExclude: undefined,
      caseIdsToInclude: undefined,
      caseIdsToExclude: undefined,
    };
  }

  const caseIdsToInclude = additionalParams?.caseIdsToInclude as Array<string | number> | undefined;
  if (!isEmpty(caseIdsToInclude)) {
    return {
      ...casesParams,
      slidesMode: false,
      caseIdsToInclude: map(caseIdsToInclude, Number),
      caseIdsToExclude: undefined,
      slideIdsToInclude: undefined,
      slideIdsToExclude: undefined,
    };
  }

  return casesParams;
};
